module.exports = __webpack_public_path__ + "img/coll_2.3b99fc63.jpg";